export const ANALYTICS_FLUSH_DATA = 'ANALYTICS_FLUSH_DATA';
export const ANALYTICS_SET_RISK = 'ANALYTICS_SET_RISK';
export const ANALYTICS_SET_PLAN = 'ANALYTICS_SET_PLAN';
export const ANALYTICS_PUSH_PAGE = 'ANALYTICS_PUSH_PAGE';
export const ANALYTICS_PUSH_EVENT = 'ANALYTICS_PUSH_EVENT';
export const ANALYTICS_ADD_ADDITIONAL_DATA = 'ANALYTICS_ADD_ADDITIONAL_DATA';
